<script>
	import { fade } from 'svelte/transition'
	import { cubicOut } from 'svelte/easing'
	import Cast from './cast.svelte'
	import Videos from './videos.svelte'
	import Images from './images.svelte'
	import bigpicture from 'bigpicture'

	export let aboutContent = ''
	try {
		//check for nested string - gravity form
		aboutContent = JSON.parse(aboutContent)
	} catch (err) {
		// use original assignment
	}
	export let conservatoryContent = ''
	export let cast = []
	export let castMembers = []
	export let videos = []
	export let images = []
	export let addContent = ''
	try {
		addContent = JSON.parse(addContent)
	} catch (err) {}
	export let maskLabel = ''
	export let starLabel = ''
	export let castLabel = ''
	export let videoLabel = ''
	export let imageLabel = ''
	export let addLabel = ''

	let activeSection = 'about'

	let contentHeight = 0
	let iconsHeight = 0
	let animateHeight

	// let windowWidth = window.innerWidth
	// let isMobile = windowWidth < 520

	$: wrapHeight = Math.max(contentHeight, iconsHeight)

	// function setHeight(node) {
	// 	contentHeight = node.clientHeight
	// }
	setTimeout(() => {
		animateHeight = true
	}, 400)

	function reCalcImgHeight() {
		//images.svelte creates macy grid, the delay initiating macy breaks the client height and makes this func necessary.
		wrapHeight = document.querySelector('.show-images').clientHeight
	}

	function addContBP() {
		let addContentAssets = document.querySelectorAll(
			'.class-additional-content a[data-bp]'
		)
		addContentAssets.forEach(function (el, index) {
			el.addEventListener('click', function (e) {
				e.preventDefault()
				bigpicture({
					el: e.target,
				})
			})
		})
	}
</script>

<div class="sc-left" bind:clientHeight={iconsHeight}>
	<button
		class="sc-btn sc-btn-mask active"
		class:active={activeSection === 'about'}
		on:click={() => (activeSection = 'about')}
	>
		<div class="sc-btn-icon">
			<svg width="93" viewbox="0 0 76.6 59.3">
				<path
					d="M43.7 0a106.1 106.1 0 0033 17.8c-6.2 19-16.2 33.5-35.7 32a34.8 34.8
					0 004.5-10.7l7.6 4.1c2.8-5.2-1.3-10.4-6.4-12.4a69.8 69.8 0 00-.3-11 18
					18 0 004 .8c1-3.4-1.5-7.7-4.9-7.4a99 99 0 00-.3-1.7l-1-5-5 1-1.1.1A95
					95 0 0143.7 0M1.5 13C-2.3 33.6 0 52 20.3 59.3 40.5 51.9 42.8 33.6 39
					13a106.1 106.1 0 01-37.5 0m9.2 28.1h19.7c0 10.7-19.7 10.7-19.7
					0m6-11.6c-4.3.6-7.6-.2-10.1-2.2 3.5-8.1 10.4-2.7 10 2.2m7.8 0c-.4-4.9
					6.6-10.3 10.1-2.2-2.5 2-5.8 2.8-10 2.2m31.4-6c2.6 3.4 5.5 5.3 8.7 5.7
					3.3-8.2-5.4-9.4-8.7-5.7"
				/>
			</svg>
			<svg width="93" viewbox="0 0 76.6 59.3">
				<path
					d="M43.7 0a106.1 106.1 0 0033 17.8c-6.2 19-16.2 33.5-35.7 32a34.8 34.8
					0 004.5-10.7l7.6 4.1c2.8-5.2-1.3-10.4-6.4-12.4a69.8 69.8 0 00-.3-11 18
					18 0 004 .8c1-3.4-1.5-7.7-4.9-7.4a99 99 0 00-.3-1.7l-1-5-5 1-1.1.1A95
					95 0 0143.7 0M1.5 13C-2.3 33.6 0 52 20.3 59.3 40.5 51.9 42.8 33.6 39
					13a106.1 106.1 0 01-37.5 0m9.2 28.1h19.7c0 10.7-19.7 10.7-19.7
					0m6-11.6c-4.3.6-7.6-.2-10.1-2.2 3.5-8.1 10.4-2.7 10 2.2m7.8 0c-.4-4.9
					6.6-10.3 10.1-2.2-2.5 2-5.8 2.8-10 2.2m31.4-6c2.6 3.4 5.5 5.3 8.7 5.7
					3.3-8.2-5.4-9.4-8.7-5.7"
				/>
			</svg>
		</div>
		<span>{maskLabel}</span>
	</button>

	{#if videos}
		<button
			class="sc-btn sc-btn-play"
			class:active={activeSection === 'video'}
			on:click={() => (activeSection = 'video')}
		>
			<div class="sc-btn-icon">
				<svg width="73" viewbox="0 0 61 61">
					<path
						d="M30.48 0A30.48 30.48 0 118.93 8.93 30.39 30.39 0 0130.48 0m11.93
						33.91c3-1.81
						3.59-4.65.51-6.6l-8.16-4.71-7.64-4.42c-3.07-1.69-5.83-.78-5.98
						2.86v18.25c.07 3.5 2.24 5.44 5.46 3.75l8.16-4.71
						7.65-4.42m4.8-20.15a23.65 23.65 0 106.92 16.72 23.57 23.57 0
						00-6.93-16.72"
					/>
				</svg>
				<svg width="73" viewbox="0 0 61 61">
					<path
						d="M30.48 0A30.48 30.48 0 118.93 8.93 30.39 30.39 0 0130.48 0m11.93
						33.91c3-1.81
						3.59-4.65.51-6.6l-8.16-4.71-7.64-4.42c-3.07-1.69-5.83-.78-5.98
						2.86v18.25c.07 3.5 2.24 5.44 5.46 3.75l8.16-4.71
						7.65-4.42m4.8-20.15a23.65 23.65 0 106.92 16.72 23.57 23.57 0
						00-6.93-16.72"
					/>
				</svg>
			</div>
			<span>{videoLabel}</span>
		</button>
	{/if}

	{#if images}
		<button
			class="sc-btn sc-btn-img"
			class:active={activeSection === 'images'}
			on:click={() => (activeSection = 'images')}
			on:click={reCalcImgHeight}
		>
			<div class="sc-btn-icon">
				<svg width="78" viewbox="0 0 227.8 188.5">
					<path
						d="M0 188.5h189.4V35.8H0zM42.1 57.2a18 18 0 11-18 18 18 18 0
						0118-18m132.7 118H14.5L71 109.8l32.3 32.3 50.4-59.1 21.2 21.2z"
					/>
					<path d="M208.9 150.9h-10.7V28.2H40.3V17.6h168.6v133.3z" />
					<path d="M227.8 133.4h-10.6V10.6H59.3V0h168.5v133.4z" />
				</svg>
				<svg width="78" viewbox="0 0 227.8 188.5">
					<path
						d="M0 188.5h189.4V35.8H0zM42.1 57.2a18 18 0 11-18 18 18 18 0
						0118-18m132.7 118H14.5L71 109.8l32.3 32.3 50.4-59.1 21.2 21.2z"
					/>
					<path d="M208.9 150.9h-10.7V28.2H40.3V17.6h168.6v133.3z" />
					<path d="M227.8 133.4h-10.6V10.6H59.3V0h168.5v133.4z" />
				</svg>
			</div>
			<span>{imageLabel}</span>
		</button>
	{/if}

	{#if cast}
		<button
			class="sc-btn sc-btn-star"
			class:active={activeSection === 'cast'}
			on:click={() => (activeSection = 'cast')}
		>
			<div class="sc-btn-icon">
				<svg width="279.7" viewbox="0 0 279.7 280.9">
					<g fill="url(#grad1)">
						<path d="M114.5 0l35.4 71.7L114.5 0z" />
						<path d="M43.7 217.8l46-24.1-46 24.1z" />
						<path d="M39.6 77.5L0 83.2l28.6 27.9L0 83.2l39.6-5.7z" />
						<path
							d="M206 130.6l-2.8-13.8-25 24.3 13 75.7 2.1
							12-10.8-5.7-68-35.7-28.9 15.2-19.3 42.5 77.9-18.1 59.1 53.9
							6.9-79.6 69.5-39.5-73.7-31.2z"
						/>
						<path d="M189.9 52.3l-14.7 17L194 72l-4.1-19.7z" />
						<path d="M89.7 193.7l24.8-13.1 70.8 37.2-70.8-37.2-24.8 13.1z" />
						<path
							d="M229 83.2l-33.7-4.9-24.8-3.6-20.6-3L114.5 0 79.1 71.7l-39.5
							5.8L0 83.2l28.6 27.9L57.3 139l-13.6 78.8 46-24.1 24.8-13.1 70.8
							37.2-13.5-78.8 29.9-29.2L229 83.2z"
						/>
						<path d="M114.5 0L79.1 71.7l-39.5 5.8 39.5-5.8L114.5 0z" />
						<path d="M28.6 111.1L57.3 139l-13.6 78.8L57.3 139l-28.7-27.9z" />
					</g>
				</svg>

				<svg width="279.7" viewbox="0 0 279.7 280.9">
					<path d="M114.5 0l35.4 71.7L114.5 0z" />
					<path d="M43.7 217.8l46-24.1-46 24.1z" />
					<path d="M39.6 77.5L0 83.2l28.6 27.9L0 83.2l39.6-5.7z" />
					<path
						d="M206 130.6l-2.8-13.8-25 24.3 13 75.7 2.1 12-10.8-5.7-68-35.7-28.9
						15.2-19.3 42.5 77.9-18.1 59.1 53.9 6.9-79.6 69.5-39.5-73.7-31.2z"
					/>
					<path d="M189.9 52.3l-14.7 17L194 72l-4.1-19.7z" />
					<path d="M89.7 193.7l24.8-13.1 70.8 37.2-70.8-37.2-24.8 13.1z" />
					<path
						d="M229 83.2l-33.7-4.9-24.8-3.6-20.6-3L114.5 0 79.1 71.7l-39.5 5.8L0
						83.2l28.6 27.9L57.3 139l-13.6 78.8 46-24.1 24.8-13.1 70.8
						37.2-13.5-78.8 29.9-29.2L229 83.2z"
					/>
					<path
						fill="#fff"
						d="M114.5 0L79.1 71.7l-39.5 5.8 39.5-5.8L114.5 0z"
					/>
					<path
						fill="#fff"
						d="M28.6 111.1L57.3 139l-13.6 78.8L57.3 139l-28.7-27.9z"
					/>
				</svg>
			</div>
			<span>{castLabel}</span>
		</button>
	{/if}

	{#if conservatoryContent}
		<button
			class="sc-btn sc-btn-star"
			class:active={activeSection === conservatoryContent}
			on:click={() => (activeSection = conservatoryContent)}
		>
			<div class="sc-btn-icon">
				<!-- <svg width="56.2" viewbox="0 0 56.2 64.8">
					<g fill="url(#grad1)">
						<path
							d="M55.4 44l-10.7-6-1.1-12.4a1.5 1.5 0 00-2.5-1l-5.2 4.8 1.6 5.5a3.5 3.5 0 01-4.7 4.2L22.3 35l-2.2 1.5 3.3 7.2L17 54.2a1.5 1.5 0 001.4 2.3L30.8 55l8.1 9.3a1.5 1.5 0 002.6-.7l2.4-12 11.4-5a1.5 1.5 0 00.1-2.6" />
						<path
							d="M22 32.7l11.5 4.6a1.5 1.5 0 00.5 0h.1a1.5 1.5 0 00.4 0 1.3 1.3 0 00.2 0 1.5 1.5 0 00.8-1.8l-1.2-4.6-2.1-7.3L40 14a1.5 1.5 0 00-1.1-2.5l-12.4-.5L20 .7a1.5 1.5 0 00-.2-.3h-.1a1.5 1.5 0 00-.2-.2 1.5 1.5 0 00-.2 0 1.4 1.4 0 00-.2-.2 1.3 1.3 0 00-.2 0 1.4 1.4 0 00-1.5 1L13 12.6l-12 3a1.5 1.5 0 00-.5 2.6l9.7 7.7-.8 12.3a1.5 1.5 0 002.3 1.4l7.5-5z" />
					</g>
				</svg>
				<svg width="56.2" viewbox="0 0 56.2 64.8"><path
						d="M55.4 44l-10.7-6-1.1-12.4a1.5 1.5 0 00-2.5-1l-5.2 4.8 1.6 5.5a3.5 3.5 0 01-4.7 4.2L22.3 35l-2.2 1.5 3.3 7.2L17 54.2a1.5 1.5 0 001.4 2.3L30.8 55l8.1 9.3a1.5 1.5 0 002.6-.7l2.4-12 11.4-5a1.5 1.5 0 00.1-2.6" />
					<path
						d="M22 32.7l11.5 4.6a1.5 1.5 0 00.5 0h.1a1.5 1.5 0 00.4 0 1.3 1.3 0 00.2 0 1.5 1.5 0 00.8-1.8l-1.2-4.6-2.1-7.3L40 14a1.5 1.5 0 00-1.1-2.5l-12.4-.5L20 .7a1.5 1.5 0 00-.2-.3h-.1a1.5 1.5 0 00-.2-.2 1.5 1.5 0 00-.2 0 1.4 1.4 0 00-.2-.2 1.3 1.3 0 00-.2 0 1.4 1.4 0 00-1.5 1L13 12.6l-12 3a1.5 1.5 0 00-.5 2.6l9.7 7.7-.8 12.3a1.5 1.5 0 002.3 1.4l7.5-5z" /></svg> -->

				<svg width="279.7" viewbox="0 0 279.7 280.9">
					<g fill="url(#grad1)">
						<path d="M114.5 0l35.4 71.7L114.5 0z" />
						<path d="M43.7 217.8l46-24.1-46 24.1z" />
						<path d="M39.6 77.5L0 83.2l28.6 27.9L0 83.2l39.6-5.7z" />
						<path
							d="M206 130.6l-2.8-13.8-25 24.3 13 75.7 2.1
							12-10.8-5.7-68-35.7-28.9 15.2-19.3 42.5 77.9-18.1 59.1 53.9
							6.9-79.6 69.5-39.5-73.7-31.2z"
						/>
						<path d="M189.9 52.3l-14.7 17L194 72l-4.1-19.7z" />
						<path d="M89.7 193.7l24.8-13.1 70.8 37.2-70.8-37.2-24.8 13.1z" />
						<path
							d="M229 83.2l-33.7-4.9-24.8-3.6-20.6-3L114.5 0 79.1 71.7l-39.5
							5.8L0 83.2l28.6 27.9L57.3 139l-13.6 78.8 46-24.1 24.8-13.1 70.8
							37.2-13.5-78.8 29.9-29.2L229 83.2z"
						/>
						<path d="M114.5 0L79.1 71.7l-39.5 5.8 39.5-5.8L114.5 0z" />
						<path d="M28.6 111.1L57.3 139l-13.6 78.8L57.3 139l-28.7-27.9z" />
					</g>
				</svg>

				<svg width="279.7" viewbox="0 0 279.7 280.9">
					<path d="M114.5 0l35.4 71.7L114.5 0z" />
					<path d="M43.7 217.8l46-24.1-46 24.1z" />
					<path d="M39.6 77.5L0 83.2l28.6 27.9L0 83.2l39.6-5.7z" />
					<path
						d="M206 130.6l-2.8-13.8-25 24.3 13 75.7 2.1 12-10.8-5.7-68-35.7-28.9
						15.2-19.3 42.5 77.9-18.1 59.1 53.9 6.9-79.6 69.5-39.5-73.7-31.2z"
					/>
					<path d="M189.9 52.3l-14.7 17L194 72l-4.1-19.7z" />
					<path d="M89.7 193.7l24.8-13.1 70.8 37.2-70.8-37.2-24.8 13.1z" />
					<path
						d="M229 83.2l-33.7-4.9-24.8-3.6-20.6-3L114.5 0 79.1 71.7l-39.5 5.8L0
						83.2l28.6 27.9L57.3 139l-13.6 78.8 46-24.1 24.8-13.1 70.8
						37.2-13.5-78.8 29.9-29.2L229 83.2z"
					/>
					<path
						fill="#fff"
						d="M114.5 0L79.1 71.7l-39.5 5.8 39.5-5.8L114.5 0z"
					/>
					<path
						fill="#fff"
						d="M28.6 111.1L57.3 139l-13.6 78.8L57.3 139l-28.7-27.9z"
					/>
				</svg>
			</div>
			<span>{starLabel}</span>
		</button>
	{/if}

	{#if addContent}
		<button
			class="sc-btn sc-btn-add"
			class:active={activeSection === 'addContent'}
			on:click={() => (activeSection = 'addContent')}
			on:click={addContBP}
		>
			<div class="sc-btn-icon">
				<svg width="279.7" viewbox="0 0 279.7 280.9">
					<g>
						<path d="M114.5 0l35.4 71.7L114.5 0z" />
						<path d="M43.7 217.8l46-24.1-46 24.1z" />
						<path d="M39.6 77.5L0 83.2l28.6 27.9L0 83.2l39.6-5.7z" />
						<path
							d="M206 130.6l-2.8-13.8-25 24.3 13 75.7 2.1
							12-10.8-5.7-68-35.7-28.9 15.2-19.3 42.5 77.9-18.1 59.1 53.9
							6.9-79.6 69.5-39.5-73.7-31.2z"
						/>
						<path d="M189.9 52.3l-14.7 17L194 72l-4.1-19.7z" />
						<path d="M89.7 193.7l24.8-13.1 70.8 37.2-70.8-37.2-24.8 13.1z" />
						<path
							d="M229 83.2l-33.7-4.9-24.8-3.6-20.6-3L114.5 0 79.1 71.7l-39.5
							5.8L0 83.2l28.6 27.9L57.3 139l-13.6 78.8 46-24.1 24.8-13.1 70.8
							37.2-13.5-78.8 29.9-29.2L229 83.2z"
						/>
						<path d="M114.5 0L79.1 71.7l-39.5 5.8 39.5-5.8L114.5 0z" />
						<path d="M28.6 111.1L57.3 139l-13.6 78.8L57.3 139l-28.7-27.9z" />
					</g>
				</svg>

				<svg width="279.7" viewbox="0 0 279.7 280.9">
					<path d="M114.5 0l35.4 71.7L114.5 0z" />
					<path d="M43.7 217.8l46-24.1-46 24.1z" />
					<path d="M39.6 77.5L0 83.2l28.6 27.9L0 83.2l39.6-5.7z" />
					<path
						d="M206 130.6l-2.8-13.8-25 24.3 13 75.7 2.1 12-10.8-5.7-68-35.7-28.9
						15.2-19.3 42.5 77.9-18.1 59.1 53.9 6.9-79.6 69.5-39.5-73.7-31.2z"
					/>
					<path d="M189.9 52.3l-14.7 17L194 72l-4.1-19.7z" />
					<path d="M89.7 193.7l24.8-13.1 70.8 37.2-70.8-37.2-24.8 13.1z" />
					<path
						d="M229 83.2l-33.7-4.9-24.8-3.6-20.6-3L114.5 0 79.1 71.7l-39.5 5.8L0
						83.2l28.6 27.9L57.3 139l-13.6 78.8 46-24.1 24.8-13.1 70.8
						37.2-13.5-78.8 29.9-29.2L229 83.2z"
					/>
					<path
						fill="#fff"
						d="M114.5 0L79.1 71.7l-39.5 5.8 39.5-5.8L114.5 0z"
					/>
					<path
						fill="#fff"
						d="M28.6 111.1L57.3 139l-13.6 78.8L57.3 139l-28.7-27.9z"
					/>
				</svg>
			</div>
			<span>{addLabel}</span>
		</button>
	{/if}
</div>

<div
	class="sc-right"
	style="padding: 0 0 {wrapHeight ? wrapHeight : 0}px"
	class:animateHeight
>
	{#if activeSection === 'about'}
		<div
			class="ss-about"
			bind:clientHeight={contentHeight}
			in:fade={{ easing: cubicOut, duration: 500, delay: 10 }}
			out:fade={{ easing: cubicOut, duration: 350 }}
		>
			{@html aboutContent}
		</div>
	{:else if activeSection === 'cast'}
		<div
			bind:clientHeight={contentHeight}
			in:fade={{ easing: cubicOut, duration: 500, delay: 10 }}
			out:fade={{ easing: cubicOut, duration: 350 }}
		>
			<Cast {cast} />
		</div>
	{:else if activeSection === 'castMembers'}
		<div
			bind:clientHeight={contentHeight}
			in:fade={{ easing: cubicOut, duration: 500, delay: 10 }}
			out:fade={{ easing: cubicOut, duration: 350 }}
		>
			<Cast {castMembers} />
		</div>
	{:else if activeSection === conservatoryContent}
		<div bind:clientHeight={contentHeight}>
			{@html conservatoryContent}
		</div>
	{:else if activeSection === 'video'}
		<div
			bind:clientHeight={contentHeight}
			in:fade={{ easing: cubicOut, duration: 500, delay: 10 }}
			out:fade={{ easing: cubicOut, duration: 350 }}
		>
			<Videos {videos} />
		</div>
	{:else if activeSection === 'images'}
		<div
			bind:clientHeight={contentHeight}
			in:fade={{ easing: cubicOut, duration: 500, delay: 10 }}
			out:fade={{ easing: cubicOut, duration: 350 }}
		>
			<Images {images} />
		</div>
	{:else if activeSection === 'addContent'}
		<div
			class="class-additional-content"
			bind:clientHeight={contentHeight}
			in:fade={{ easing: cubicOut, duration: 500, delay: 10 }}
			out:fade={{ easing: cubicOut, duration: 350 }}
		>
			{@html addContent}
		</div>
	{/if}
</div>
